import React, { useState, useEffect, useContext } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import MaleEductionChart from "./MaleEductionChart";
import FemaleEductionChart from "./FemaleEductionChart";
import LocalEducationChart from "./LocalEducationChart";
import MaleAreaChart from "./MaleAreaChart";
import FemaleAreaChart from "./FemaleAreaChart";
import ChildrenAreaChart from "./ChildrenAreaChart";
import EductionGenderChart from "./EductionGenderChart";
import PlannedSpentChart from "./PlannedSpentChart";
import { useLocation, useParams } from "react-router-dom";
import { PublicApi } from "api/api";
import { useTranslation } from "react-i18next"; 
import { CommonDataContext } from "contexts/CommonDataContext/CommonDataContext";

const countryNames = ['Bosnia and Herzegovina', 'Kosovo', 'Montenegro', 'North Macedonia', 'Serbia'];
const publicApi = new PublicApi();

function EducationIndicators() {
  const context = useContext(CommonDataContext);
  const [selectedYear, setSelectedYear] = useState("2024");
  const [yearsList, setYearsList] = useState([]);
  const [indicatorList, setIndicatorList] = useState([]);
  const [budgetList,setBudgetList] = useState([]);
  const [selectedCountry,setSelectedCountry] = useState({});

  const { state } = useLocation();
  
  const { t } = useTranslation();
  console.log(state);
  const handleSelect = (year) => {
    setSelectedYear(year);
  };

  useEffect(() => {
    setSelectedCountry(context?.countries?.find(data => data.id === state.countryId));
  },[state])


  const getAllYearsList = async () => {
    const response = await publicApi.apiPublicGetAllYearsList();
    setYearsList(response?.data?.yearsList)
  };

  const getAreaBudget = async() => {
    const budgetResponse = await publicApi.apiPublicGetBudgetByArea({ countryId: state?.countryId, areaId: state?.areaId });
    setBudgetList(budgetResponse?.data)
  }

  const getBudgetByYear = async (year) => {
    const response = await publicApi.apiPublicGetIndicatorByArea({ countryId: state?.countryId, areaId: state?.areaId, year: year });
    setIndicatorList(response?.data)

  }

  useEffect(() => {
    getAllYearsList();
    getAreaBudget()
  }, []);

  useEffect(() => {
    setIndicatorList([{}])
    getBudgetByYear(selectedYear)
  }, [selectedYear]);


  const params = useParams()

  return (
    <section>
      <div className="d-sm-flex align-items-center justify-content-between gap-1 mb-sm-5 mb-3">
       
        <div className="f-s-18 f-w-400">{params?.area}  {t("area:indicators","indicators")} </div>
        <div className="dropdown-year mb-0 mt-sm-0 mt-3">
          <h6>{t("home:regional:select-year","Select year")}</h6>
          <Dropdown>
            <Dropdown.Toggle id="dropdown-year">{selectedYear}</Dropdown.Toggle>
            <Dropdown.Menu>
              {yearsList.map((year) => (
                <Dropdown.Item
                  key={year}
                  onClick={() => handleSelect(year)}
                  active={selectedYear === year}
                >
                  {year}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <div className="row g-4 justify-content-center">
        {indicatorList.length > 0 ? indicatorList?.map(indicator => {
          if (indicator?.typeOfAnswerValue === 'male/female') {
            const chartData = [{
              name: t("area:male","Male"),
              count: indicator?.male
            },
            {
              name: t("area:female","Female"),
              count: indicator?.female
            }]
            return <div className="col-md-6">
           {( indicator?.male > 0 || indicator?.female) &&  <div className="chart-card">
                <span className="chart-badge">{selectedYear}</span>
                <h5 className="mb-sm-4 mb-3">{indicator?.indicatorName}</h5>
                <FemaleEductionChart data={chartData} />
                <ul className="legends-group mt-4 mb-0 d-sm-flex align-items-center justify-content-evenly gap-1">
                  <li className="mb-sm-0">
                    <img
                      src="/images/png/spent-chart3.png"
                      alt="planned-spent-chart1"
                    />
                    <span>{t("area:male","Male")}</span>
                  </li>
                  <li className="mb-0">
                    <img
                      src="/images/png/spent-chart2.png"
                      alt="planned-spent-chart2"
                    />
                    <span>{t("area:female","Female")}</span>
                  </li>
                </ul>
              </div>}
            </div>
          }
          if(indicator?.typeOfAnswerValue === 'male/female/childrens'){
            const chartData = [{
              name: t("area:male","Male"),
              count: indicator?.male
            },
            {
              name: t("area:female","Female"),
              count: indicator?.female
            },
          {
            
            name : t("area:childrens","Childrens"),
            count: indicator?.childrens
          }]
            return (indicator?.male > 0 || indicator?.female > 0 || indicator?.childrens > 0) && <div className="col-md-6">
              <div className="chart-card">
                <span className="chart-badge">{selectedYear}</span>
                <h5 className="mb-sm-4 mb-3">{indicator?.indicatorName}</h5>
                <LocalEducationChart data={chartData} />
                <ul className="legends-group mt-4 mb-0 d-sm-flex align-items-center justify-content-evenly gap-1">
              <li className="mb-sm-0">
                <img
                  src="/images/png/education-chart3.png"
                  alt="planned-spent-chart1"
                />
                <span>{t("area:male","Male")}</span>
              </li>
              <li className="mb-0">
                <img
                  src="/images/png/education-chart1.png"
                  alt="planned-spent-chart2"
                />
                <span>{t("area:female","Female")}</span>
              </li>
              <li className="mb-0">
                <img
                  src="/images/png/education-chart2.png"
                  alt="planned-spent-chart2"
                />
                <span>{t("area:childrens","Childrens")}</span>
              </li>
            </ul>
              </div>
            </div>
          }
          if(indicator?.typeOfAnswerValue === 'total'){
            const chartData = [
              {
                name :  t("area:total","Total"),
                count : indicator?.total
              }
            ]

            return  <><div className="col-md-6">
          {indicator?.total > 0 &&<div className="chart-card">
              <span className="chart-badge">{selectedYear}</span>
              <h5 className="mb-sm-4 mb-3">{indicator?.indicatorName}</h5>
              <FemaleAreaChart data={chartData} />
              <div className="d-flex align-items-center gap-3 mt-4 justify-content-center">
                <img src="/images/svg/map.svg" alt="Dollar" />
                <span>{params?.country}</span>
              </div>
            </div>}
          </div></>
          }
          
        }): <div className="indicator-not-found">{t("indicator:not-found","This year's indicators are not available for this particular area. Please try selecting a different year.")}</div>}
        {/* <div className="col-md-6">
          <div className="chart-card">
            <span className="chart-badge">2024</span>
            <h5 className="mb-sm-4 mb-3 text-center">Male Eduction Distribution</h5>
            <MaleEductionChart />
          </div>
        </div>
        <div className="col-md-6">
          <div className="chart-card">
            <span className="chart-badge">2024</span>
            <h5 className="mb-sm-4 mb-3 text-center">Female Eduction Distribution</h5>
            <FemaleEductionChart />
          </div>
        </div>
        <div className="col-md-6">
          <div className="chart-card">
            <span className="chart-badge">2024</span>
            <h5 className="mb-sm-4 mb-3 text-center">
              Distribution of Eduction by Gender
            </h5>
            <EductionGenderChart />
          </div>
        </div>
        <div className="col-md-6">
          <div className="chart-card">
            <span className="chart-badge">2024</span>
            <h5 className="mb-sm-4 mb-3">Local {params?.area} Indicators Status</h5>
            <LocalEducationChart />
            <ul className="legends-group mt-4 mb-0 d-sm-flex align-items-center justify-content-evenly gap-1">
              <li className="mb-sm-0">
                <img
                  src="/images/png/education-chart1.png"
                  alt="planned-spent-chart1"
                />
                <span>Educated people</span>
              </li>
              <li className="mb-0">
                <img
                  src="/images/png/education-chart2.png"
                  alt="planned-spent-chart2"
                />
                <span>Non Educated People</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-xl-4 col-md-6">
          <div className="chart-card">
            <span className="chart-badge">2024</span>
            <h5 className="mb-sm-4 mb-3">Total Male in {params?.area} Area</h5>
            <MaleAreaChart />
            <div className="d-flex align-items-center gap-3 mt-4 justify-content-center">
              <img src="/images/svg/map.svg" alt="Dollar" />
              <span>{countryNames[params?.country]}</span>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-md-6">
          <div className="chart-card">
            <span className="chart-badge">2024</span>
            <h5 className="mb-sm-4 mb-3">Total Female in {params?.area} Area</h5>
            <FemaleAreaChart />
            <div className="d-flex align-items-center gap-3 mt-4 justify-content-center">
              <img src="/images/svg/map.svg" alt="Dollar" />
              <span>{countryNames[params?.country]}</span>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-md-6">
          <div className="chart-card">
            <span className="chart-badge">2024</span>
            <h5 className="mb-sm-4 mb-3">Total Children in {params?.area} Area</h5>
            <ChildrenAreaChart />
            <div className="d-flex align-items-center gap-3 mt-4 justify-content-center">
              <img src="/images/svg/map.svg" alt="Dollar" />
              <span>{countryNames[params?.country]}</span>
            </div>
          </div>
        </div> */}
        <div className="col-12">
      { budgetList && budgetList?.length > 0 &&   <div className="budget-distribution align-items-stretch">
            <div className="d-lg-block d-none">
              <div className="vertical-design"></div>
            </div>
            <div>
              <ul className="d-sm-flex align-items-center justify-content-center gap-5 ps-0">
                <li className="d-flex align-items-center gap-2">
                  <img
                    src="/images/png/planned-budget.png"
                    alt="planned-spent-chart1"
                  />
              
                  <span>{t("area:planned-budget","Planned Budget")}</span>
                </li>
                <li className="d-flex align-items-center gap-2">
                  <img
                    src="/images/png/spent-budget.png"
                    alt="planned-spent-chart2"
                  />
                  <span>{t("area:spent-budget","Spent Budget")}</span>
                </li>
              </ul>
              <PlannedSpentChart selectedCountry={selectedCountry?.currency || ''} data={budgetList} title={[t("area:planned-budget","Planned Budget"),t("area:spent-budget","Spent Budget")]} />
              <p className="mt-md-5 mt-1">
                {t("area:description","For the area, when clicked, a page can be displayed with graphs like a pie chart and bar chart to visually represent the planned vs. spent budget for the particular year. These charts would provide a detailed breakdown of the allocation and usage of funds in initiatives. This would provide a more detailed view, breaking down specific categories within the sector, such as infrastructure, training, student support, and more, comparing planned and spent amounts for each.")}

              </p>
            </div>
          </div>}
        </div>
      </div>
    </section>
  );
}

export default EducationIndicators;
